import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/@services/api.service';

@Component({
  selector: 'app-accept-privacy-policy-modal',
  templateUrl: './accept-privacy-policy-modal.component.html',
  styleUrls: ['./accept-privacy-policy-modal.component.scss']
})
export class AcceptPrivacyPolicyModalComponent implements OnInit {

  privacyPolicyAcceptedDate = false;

  customLoader = false;

  constructor(
    private api: ApiService,
    private matDialog: MatDialog 
  ) { }

  ngOnInit(): void {
  }


   submit(){
   
    if(!this.privacyPolicyAcceptedDate){
      return;
    }
   
    this.customLoader = true
    let dat = {
    
    }
    if(window.location.href?.includes('/visitor-approval?')){
      localStorage.setItem('privacyPolicyAcceptedDate', new Date().toISOString())
      this.customLoader = false;
      this.matDialog.closeAll();
      return;
    }

    let type = 'users';


    if(window.location.href?.includes('/visitor-checkin?')){
      type = 'visitors'
    }

    this.api.put(`${type}/update/privacyPolicyAcceptedDate`, dat).subscribe((res:any)=>{
     
      if(!res.error){
          this.matDialog.closeAll()
      }
      this.matDialog.closeAll()
      localStorage.removeItem('loggedInByOkta')

     this.customLoader = false;
    },(err)=>{
      this.customLoader = false;
       this.matDialog.closeAll()
      // this.errorMsg = err.error.message
    })
  }

}
